import axios from 'axios';

export const AddUserToRoom = async (communicationUserId, roomId, role, contextData) => {
  const { __merchantId, __userId, appInsightTrack, addUserToRoomUrl, headers } = contextData;

  try {
    await axios.post(
      addUserToRoomUrl,
      {
        communicationUserId,
        roomId,
        role,
        merchantId: __merchantId,
        userId: __userId,
      },
      { headers }
    );
  } catch (error) {
    console.error(`Error adding user ${communicationUserId} to room ${roomId}:`, error);
    appInsightTrack(__merchantId, __userId, "Error in adding user to room", "", error);
    throw error; // Rethrow error so caller can handle
  }
};

export const CallBackGivenForDismiss = () => {
  if (
      navigator != null &&
      navigator.userAgent != null &&
      navigator.userAgent !== ""
  ) {
      if (navigator.userAgent.indexOf("com.vagaro.customerios") > -1 ) {
          window.location.href = process.env.REACT_APP_WEB_URL_SUBDOMAIN + "myaccount/appointments" ;
      }
      else if (navigator.userAgent.indexOf("com.vagaro.iospro") > -1 ) {
          var objData = '5006||~||{"message": "","messageType": 0,"screenTitle":"","screenType": 0,"navType": 0,"action": "113" }'; 
          setTimeout(() => { window.location = "js-call:myObjectiveCFunction:" + objData }, 100);
      }
  }
}

export const CallBackGivenForReJoin = (staticGID, merchantId, userId, url, domain) => {
  if (
    navigator != null &&
    navigator.userAgent != null &&
    navigator.userAgent !== ""
  ) {
    if (navigator.userAgent.indexOf("com.vagaro.customerios") > -1) {
      // Temp Stop callback For Customer App
      // var objData = '{"message": "","messageType": 0,"screenTitle":"","screenType": 0,"navType": 0,"action": "54|~|' + uniqueID + '|~|' + merchantId + '|~|' + userId + '|~|' + url + '|~|' + domain + '" }';
      //if (!(window.JSInterface === undefined)) window.JSInterface.CallWSMethod(objData);
      window.location.href = process.env.REACT_APP_WEB_URL_SUBDOMAIN + "livestream/" + staticGID;
    }
  }
}